<template>
    <v-pagination
        color="#fff"
        class="custom-pagination"
		:total-visible="10"
		v-model="currentPage"
		:length="pageCount"
    />
</template>

<script>
export default {
    props: {
        page: {
            type: Number,
            default: 0
        },
        pageCount: {
            type: Number,
            default: 0
        }
    },
    computed: {
        currentPage: {
            get() {
                return this.page
            },
            set(value) {
               this.$emit('pageChange', value)
            }
        }
    }
}
</script>

<style lang="scss">
.custom-pagination {
    .v-pagination {
        &__navigation {
            display: none;
        }
        &__item {
            color: var(--accent-color) !important;
            box-shadow: none;
            font-size: 15px;
            font-weight: 600;

            &--active {
                color: #fff !important;
                background-color: var(--accent-color) !important;
            }
        }
        &__more {
            color: var(--accent-color);
        }
    }
}
</style>